export default __webpack_public_path__ + "static/media/aplaystore.ed9de674.svg";